import { Box, Typography } from "@mui/material";
import axios from "axios";
import { BASE_URL } from "../../../../../constant/apiUrl";
import { useDispatch } from "react-redux";
import { deleteApp } from "../../../../../slices/appadminSlice";
import { showSuccessToast } from "../../../../../utils/Toast/toast";
import { useState } from "react";
import Loading from "../../../../../utils/Loader";
import { Modal } from "pepsico-ds";

export default function RemoveAction({ data, onCancel }) {
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const token = localStorage.getItem("auth_token");
  const dispatch = useDispatch();
  const handleRemove = async () => {
    setLoading(true);
    try {
      const remove = await axios.delete(
        `${BASE_URL}/admin/apps/delete/${data?.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (remove?.status === 200) {
        onCancel();
        dispatch(deleteApp(data?.id));
        showSuccessToast("App Removed Successfully !");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Box
        onClick={() => {
          setOpenModal(!openModal);
        }}
        sx={{
          display: "flex",
          padding: "8px 0px",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
        }}
      >
        {loading && <Loading />}
        <Typography
          sx={{
            color: "var(--Tokens-Button-Borderless, #005CBC)",
            fontFamily: "var(--Typography-Font-Family-Body, Inter)",
            fontSize: "var(--Font-Size-Body, 16px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-Body, 22px)",
          }}
        >
          Remove
        </Typography>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M16 9.00098V19.001H8V9.00098H16ZM14.5 3.00098H9.5L8.5 4.00098H5V6.00098H19V4.00098H15.5L14.5 3.00098ZM18 7.00098H6V19.001C6 20.101 6.9 21.001 8 21.001H16C17.1 21.001 18 20.101 18 19.001V7.00098Z"
            fill="#005CBC"
          />
        </svg>
      </Box>
      <Modal
        // className="app-modal"
        onCloseModal={() => setOpenModal(false)}
        hideCloseButton={true}
        showModal={openModal}
        showAuxiliaryButton={false}
        showTertiaryButton={false}
        showLink={false}
        // auxiliaryButtonProps={{}}
        title="Remove App"
        type="S"
        showPrimaryButton={true}
        showSecondaryButton={true}
        primaryButtonProps={{
          text: "Remove",
          variant: "primary",
          onClick: () => {
            void handleRemove(); // ✅ Sonar-safe
          },
        }}
        secondaryButtonProps={{
          text: "Cancel",
          variant: "secondary",
          onClick: () => setOpenModal(false),
        }}
      >
        <Box sx={{ marginTop: "2.5rem" }}>
          <Typography sx={{ marginBottom: "1rem" }}>
            After an App is Removed, you can't undo it. Are you sure?
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
